import { useMutation } from "@tanstack/vue-query";

import type { Newsletter } from "@/types/newsletter";

import { type BasicSubscriber, type SubscribeResult, subscribe } from "../lib";

declare var REFERRING_SUBSCRIBER_ID: string;

interface UseSubscribeOptions {
  newsletter: Newsletter;
  onSuccess?: (subscriber: BasicSubscriber) => void;
  onError?: (error: string | object, data?: any) => void;
}

export function useSubscribe({
  newsletter,
  onSuccess,
  onError,
}: UseSubscribeOptions) {
  return useMutation({
    async mutationFn(params: {
      emailAddress: string;
      metadata: Record<string, string>;
      turnstileResponseToken: string;
      formId: string | null;
    }): Promise<SubscribeResult> {
      return subscribe(
        params.emailAddress,
        params.metadata,
        newsletter,
        REFERRING_SUBSCRIBER_ID || null,
        params.turnstileResponseToken || null,
        params.formId
      );
    },
    onSuccess(result) {
      if ("subscriber" in result) {
        onSuccess?.(result.subscriber);
      } else {
        onError?.(result.error, result.data);
      }
    },
  });
}
